import React from "react";
import { formatOutcomeSummaryShortI18n, useTranslation } from "../../../i18n";

const DeletionCaseOutcomeSummary = ({ summary, compact = false }) => {
  const { t } = useTranslation();

  if (!summary || summary.total === 0) {
    return <span className="text-[12px] text-[#94a3b8]">—</span>;
  }

  if (compact) {
    return (
      <span className="text-[12px] text-[#475569]">
        {formatOutcomeSummaryShortI18n(t, summary)}
      </span>
    );
  }

  return (
    <div className="flex flex-wrap gap-2">
      <span className="rounded-full bg-emerald-50 px-2.5 py-1 text-[11px] font-semibold text-emerald-800 ring-1 ring-emerald-200">
        {t("deletionCaseUi.deletedCount", { count: summary.deleted })}
      </span>
      <span className="rounded-full bg-red-50 px-2.5 py-1 text-[11px] font-semibold text-red-800 ring-1 ring-red-200">
        {t("deletionCaseUi.notDeletedCount", { count: summary.notDeleted })}
      </span>
      {summary.pending > 0 ? (
        <span className="rounded-full bg-slate-100 px-2.5 py-1 text-[11px] font-semibold text-slate-600 ring-1 ring-slate-200">
          {t("deletionCaseUi.pendingCount", { count: summary.pending })}
        </span>
      ) : null}
      {summary.isPartial ? (
        <span className="rounded-full bg-amber-50 px-2.5 py-1 text-[11px] font-semibold text-amber-900 ring-1 ring-amber-200">
          {t("deletionCaseUi.partiallyComplete")}
        </span>
      ) : null}
    </div>
  );
};

export default DeletionCaseOutcomeSummary;
